import React from 'react';

import Button from '@webteam/button';

import getStartedIcon from '../../images/kotlin-get-started-icon.svg'

import './get-started-banner.pcss';

const GetStartedBanner = () => (
  <div className="wt-row wt-row_size_m wt-offset-top-96">
    <div className="wt-col-12 get-started-banner__wrap">
      <div className="wt-row wt-row_size_m wt-row_justify_between wt-row_align-items_center wt-row_nowrap wt-row-sm_direction_column wt-row-sm_align-items_start get-started-banner">
        <div className="wt-col-inline">
          <img className="get-started-icon" src={getStartedIcon} alt="" />
        </div>
        <div className="wt-col-inline wt-col-sm-10 rs-subtitle-2 wt-offset-top-sm-24">
          Create your first app with Kotlin Multiplatform Mobile
        </div>
        <div className="wt-col-inline wt-offset-top-sm-24">
          <Button
            href="https://kotlinlang.org/docs/kmm-getting-started.html"
            size="m"
            mode="primary"
          >
            Get started
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default GetStartedBanner;
